import{gql as r}from"@apollo/client";const e=r`
  query getDirectoryUsingFriendlyUrl($friendlyUrl: String!, $projectId: String!) {
    directory {
      getDirectoryUsingFriendlyUrl: get(projectId: $projectId, url: $friendlyUrl) {
        address {
          city
          country
          latitude
          line1
          longitude
          postcode
          state
          suburb
        }
        description
        email
        friendlyUrl
        id
        phoneNumber
        title
        url
      }
    }
  }
`;export{e as GET_DIRECTORY_USING_FRIENDLY_URL_QUERY};
//# sourceMappingURL=useGetDirectoryUsingFriendlyUrl.graphql.js.map
